import React from 'react';
import { withRouter } from 'react-router-dom';
import withAuthorization from '../../hoc/withAuthorization';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import AddRenterForm from '../../components/Renter/AddRenterForm';

const AddRenterPage = props =>
    <LargePaper>
        <h1 style={stylesDefault.title}>Ajouter un loueur</h1>
        <AddRenterForm history={props.history}/>
    </LargePaper>;

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(withRouter(AddRenterPage));



// WEBPACK FOOTER //
// ./src/containers/AddRenterPage/AddRenterPage.jsx